export const ROLE_UNREGISTERED_CLIENT = 'ROLE_UNREGISTERED_CLIENT'
export const ROLE_CLIENT = 'ROLE_CLIENT'

export const ROLE_EMPLOYEE = 'ROLE_EMPLOYEE'
export const ROLE_DOCTOR_EMPLOYEE = 'ROLE_DOCTOR_EMPLOYEE'
export const ROLE_CHIEF_DOCTOR_EMPLOYEE = 'ROLE_CHIEF_DOCTOR_EMPLOYEE'
export const ROLE_ADMIN_EMPLOYEE = 'ROLE_ADMIN_EMPLOYEE'
export const ROLE_HR_EMPLOYEE = 'ROLE_HR_EMPLOYEE'
export const ROLE_AGENTS_ADMIN_EMPLOYEE = 'ROLE_AGENTS_ADMIN_EMPLOYEE'
export const ROLE_IDDQD = 'ROLE_IDDQD'
export const ROLE_HEAD_DOCTOR = 'ROLE_HEAD_DOCTOR'
export const ROLE_HEAD_DEPARTMENT = 'ROLE_HEAD_DEPARTMENT'
export const ROLE_OFFICE = 'ROLE_OFFICE'

export const ROLE_HHO = 'ROLE_HHO'

export const ROLE_COLLAB = 'ROLE_COLLAB'
export const ROLE_BUSINESS_COLLAB = 'ROLE_BUSINESS_COLLAB'
export const ROLE_ADMIN_BUSINESS_COLLAB = 'ROLE_ADMIN_BUSINESS_COLLAB'
export const ROLE_UNREGISTERED_COLLAB = 'ROLE_UNREGISTERED_COLLAB'

export const ROLE_ALLOWED_TO_SWITCH = 'ROLE_ALLOWED_TO_SWITCH'

class AuthUser {
  constructor (dto = {}) {
    this.uuid = dto.uuid || null
    this.username = dto.username || 'Anonymous'
    this.roles = dto.roles || []
  }

  getUuid () {
    return this.uuid
  }

  getRoles () {
    return this.roles
  }

  getUsername () {
    return this.username
  }

  isAdmin () {
    return this.roles.indexOf(ROLE_ADMIN_EMPLOYEE) > -1
  }

  isHR () {
    return this.roles.indexOf(ROLE_HR_EMPLOYEE) > -1
  }

  isDoctor () {
    return this.roles.indexOf(ROLE_DOCTOR_EMPLOYEE) > -1
  }

  isChiefDoctor () {
    return this.roles.indexOf(ROLE_CHIEF_DOCTOR_EMPLOYEE) > -1
  }

  isAgentsAdmin () {
    return this.roles.indexOf(ROLE_AGENTS_ADMIN_EMPLOYEE) > -1
  }

  isGod () {
    return this.roles.indexOf(ROLE_IDDQD) > -1
  }

  isHeadDoctor () {
    return this.roles.indexOf(ROLE_HEAD_DOCTOR) > -1
  }

  isHeadDepartment () {
    return this.roles.indexOf(ROLE_HEAD_DEPARTMENT) > -1
  }

  isHHO () {
    return this.roles.indexOf(ROLE_HHO) > -1
  }

  isOffice () {
    return this.roles.indexOf(ROLE_OFFICE) > -1
  }

  canLoginToAccount () {
    return this.roles.indexOf(ROLE_ALLOWED_TO_SWITCH) > -1
  }
}

export default AuthUser
